import { RoutesPaths } from "../../constants/user-routes"
import {
  EXPERIMENTAL_SECTION_KEYS,
  SECTION_KEY_ALIASES,
  SECTION_KEYS
} from "../DisputesPage/pages/ConfigurePage/schema/sections"
import { RECEIPT_CONFIGURE_SLUGS } from "../ReceiptPage/constants/receipt-configure-slugs"

// Every /recover/configure/:section URL the wizard can land on: both flows' step keys
// plus the legacy aliases that redirect onto them. Read from the schema rather than
// retyped here, so a new step cannot silently lose its header.
const RECOVER_CONFIGURE_SECTIONS = [
  ...new Set([...SECTION_KEYS, ...EXPERIMENTAL_SECTION_KEYS, ...Object.keys(SECTION_KEY_ALIASES)])
]

const recoverConfigure = {
  title: "Configure",
  description: "Set up the building blocks we use to fight your disputes.",
  icon: "settings"
}

export const pagesConfig = {
  [RoutesPaths.dashboard.root]: {
    title: "Dashboard",
    description: "Here’s an overview of all alerts.",
    icon: "homesidebar",
    buttonText: "Watch tutorial",
    videoUrl: "https://www.youtube.com/watch?v=vBIyZCsxwkU"
  },
  [RoutesPaths.alerts.all]: {
    title: "Alerts",
    description: "View the status of all alerts.",
    icon: "alerts",
    buttonText: "Watch tutorial",
    videoUrl: "https://www.youtube.com/watch?v=Llzdv1Exymw"
  },
  // Integrate tab of Configure — Integrations' page header moved here with it,
  // "View logs" included.
  ...["processors", "subscriptions", "notifications"].reduce((acc, slug) => {
    acc[`${RoutesPaths.configure.root}/${slug}`] = {
      title: "Configure",
      description: "View and manage your enrollments, refunds, and integrations.",
      icon: "settings",
      queryParam: "integrations-logs",
      queryButtonText: "View logs"
    }
    return acc
  }, {}),
  // Recover / Disputes. `pagesConfig` is matched on the EXACT pathname (see
  // Layout/index.js), and no title means no <TitleSection> at all — which is why the
  // page-header action slot had nothing to render into before these entries existed.
  // The dynamic /recover/details/:dispute_id cannot be keyed this way and stays
  // headerless.
  [RoutesPaths.recover.all]: {
    title: "Disputes",
    description: "All chargebacks from your connected processors.",
    icon: "receipt_check"
  },
  [RoutesPaths.recover.configure]: recoverConfigure,
  ...RECOVER_CONFIGURE_SECTIONS.reduce((acc, section) => {
    acc[RoutesPaths.recover.configure_section(section)] = recoverConfigure
    return acc
  }, {}),
  [RoutesPaths.recover.analytics]: {
    title: "Analytics",
    description: "Win rate, recoveries, and where you win disputes.",
    icon: "analytics"
  },
  [RoutesPaths.recover.preferences]: {
    title: "Preferences",
    description: "Control how Recover behaves when disputes arrive.",
    icon: "settings"
  },
  [RoutesPaths.receipts.all]: {
    title: "Receipt",
    description: "Share purchase details with cardholders to prevent disputes.",
    icon: "receipt_bill"
  },
  [RoutesPaths.receipts.configure_profile]: {
    title: "Configure",
    description: "Set up the details cardholders see for each charge.",
    icon: "settings"
  },
  [RoutesPaths.receipts.configure_business]: {
    title: "Configure",
    description: "View and manage your enrollments and refund settings.",
    icon: "settings"
  },
  // Wizard steps plus the Business tab (CHA-10781) — every Configure URL shares
  // one page header.
  ...Object.values(RECEIPT_CONFIGURE_SLUGS).reduce((acc, slug) => {
    acc[RoutesPaths.receipts.configure_profile_hash(slug)] = {
      title: "Configure",
      description: "Set up the details cardholders see for each charge.",
      icon: "settings"
    }
    return acc
  }, {}),
  "/business_settings/integrations": {
    title: "Integrations",
    description: "Integrate your gateway to prevent chargebacks.",
    icon: "integrations",
    buttonText: "Watch tutorial",
    videoUrl: "https://www.youtube.com/watch?v=DQfWiW5ZIbg"
  },
  [RoutesPaths.credits]: {
    title: "Credits",
    description: "View the status of all credit requests.",
    icon: "alerts"
  },
  [RoutesPaths.perks]: {
    title: "Perks & Benefits",
    description: "Exclusive deals and discounts from our partners.",
    icon: "gift"
  },
  [RoutesPaths.configure.enrollment]: {
    title: "Configure",
    description: "View and manage your enrollments, refunds, and integrations.",
    icon: "settings"
  },
  [RoutesPaths.configure.auto_refund]: {
    title: "Configure",
    description: "View and manage your enrollments, refunds, and integrations.",
    queryParam: "auto-refund-logs",
    queryButtonText: "View logs",
    icon: "settings"
  },
  [RoutesPaths.home]: {
    title: "Home",
    description: "Here's an overview of your account.",
    icon: "homesidebar"
  },
  "/business_settings/my_business": {
    title: "My Business",
    description: "Manage your business profile and alert rules.",
    icon: "settings",
    buttonText: "Watch tutorial",
    videoUrl: "https://www.youtube.com/watch?v=x4cxRrXFjEk"
  },
  "/business_settings/billing": {
    title: "Billing & Invoices",
    description: "All information about your billing and invoices.",
    icon: "settings"
    //buttonText: "Watch tutorial",
    //videoUrl: "https://www.youtube.com/watch?v=f4RclD3ufD8",
  },
  "/business_settings/balance": {
    title: "Balance & Payment methods",
    description: "All information about your balance and payment methods.",
    icon: "settings"
  },
  "/business_settings/enrollment": {
    title: "Enrollment",
    description: "Turn on your coverage, you will only pay when we prevent a chargeback.",
    icon: "settings",
    buttonText: "Watch tutorial",
    videoUrl: "https://www.youtube.com/watch?v=nVcXJfPOo0U"
  },
  [RoutesPaths.deflect.analytics]: {
    title: "Analytics",
    description: "Bank inquiries, match rate, and what Digital Receipt deflects.",
    icon: "line_chart"
  }
}
